/**
 * Image Preloader Utility
 * Preloads critical images for faster page rendering
 */

// Critical images that should be loaded immediately
const CRITICAL_IMAGES = [
  '/nature-around-you.webp',
  '/community-around-you.webp',
  '/design-around-you.webp',
  '/life-around-you.webp',
];

/**
 * Preload a single image
 * @param {string} src - Image URL
 * @returns {Promise} - Resolves when image loads
 */
const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(src);
    img.onerror = () => reject(src);
    img.src = src;
  });
};

/**
 * Preload critical images immediately
 */
export const preloadCriticalImages = () => {
  // Only preload local images to avoid CORS issues
  CRITICAL_IMAGES.forEach(src => {
    if (src.startsWith('/')) {
      preloadImage(src).catch(() => {});
    }
  });
};

/**
 * Initialize image preloading
 */
export const initImagePreloader = () => {
  // Use requestIdleCallback for non-blocking preload
  if (typeof window !== 'undefined') {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => preloadCriticalImages());
    } else {
      setTimeout(preloadCriticalImages, 100);
    }
  }
};

export default {
  preloadImage,
  preloadCriticalImages,
  initImagePreloader,
};
